/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RelationshipType } from './RelationshipType';
import {
    RelationshipTypeFromJSON,
    RelationshipTypeFromJSONTyped,
    RelationshipTypeToJSON,
    RelationshipTypeToJSONTyped,
} from './RelationshipType';

/**
 * 
 * @export
 * @interface ReferralLinkTextBody
 */
export interface ReferralLinkTextBody {
    /**
     * 
     * @type {string}
     * @memberof ReferralLinkTextBody
     */
    header?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralLinkTextBody
     */
    description?: string;
    /**
     * 
     * @type {RelationshipType}
     * @memberof ReferralLinkTextBody
     */
    relationshipType: RelationshipType;
}



/**
 * Check if a given object implements the ReferralLinkTextBody interface.
 */
export function instanceOfReferralLinkTextBody(value: object): value is ReferralLinkTextBody {
    if (!('relationshipType' in value) || value['relationshipType'] === undefined) return false;
    return true;
}

export function ReferralLinkTextBodyFromJSON(json: any): ReferralLinkTextBody {
    return ReferralLinkTextBodyFromJSONTyped(json, false);
}

export function ReferralLinkTextBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralLinkTextBody {
    if (json == null) {
        return json;
    }
    return {
        
        'header': json['header'] == null ? undefined : json['header'],
        'description': json['description'] == null ? undefined : json['description'],
        'relationshipType': RelationshipTypeFromJSON(json['relationshipType']),
    };
}

export function ReferralLinkTextBodyToJSON(json: any): ReferralLinkTextBody {
    return ReferralLinkTextBodyToJSONTyped(json, false);
}

export function ReferralLinkTextBodyToJSONTyped(value?: ReferralLinkTextBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'header': value['header'],
        'description': value['description'],
        'relationshipType': RelationshipTypeToJSON(value['relationshipType']),
    };
}

